{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "system",
  "title": "System",
  "description": "Website agent infrastructure: API endpoints, LLM model configuration.",
  "type": "object",
  "x-access": "staff",
  "properties": {
    "api_endpoint": {
      "ui:sectionTitle": "Endpoints",
      "ui:sectionDescription": "The service endpoints Rose talks to.",
      "ui:sectionIcon": "Globe",
      "type": [
        "string",
        "null"
      ],
      "format": "uri",
      "ui:description": "Primary API endpoint for the website agent"
    },
    "evaluation_endpoint": {
      "type": "string",
      "format": "uri",
      "ui:description": "Evaluation API endpoint (global, same for all clients)",
      "readOnly": true
    },
    "conversation_endpoint": {
      "type": "string",
      "format": "uri",
      "ui:description": "Conversation API endpoint (global, same for all clients)",
      "readOnly": true
    },
    "model": {
      "type": [
        "object",
        "null"
      ],
      "ui:description": "LLM model configuration",
      "properties": {
        "provider": {
          "type": "string",
          "enum": [
            "azure",
            "openai",
            "anthropic",
            "google",
            "cerebras",
            "groq"
          ],
          "ui:description": "LLM provider"
        },
        "name": {
          "type": "string",
          "ui:description": "Model name (e.g. gpt-4.1-mini, claude-sonnet-4-5)",
          "maxLength": 100,
          "minLength": 1
        }
      },
      "required": [
        "provider",
        "name"
      ]
    },
    "config_locked": {
      "ui:sectionTitle": "Tenant access & plan",
      "ui:sectionDescription": "Tenant-level, cross-agent: config lock, service tier, and knowledge ingestion source.",
      "ui:sectionIcon": "Lock",
      "type": "boolean",
      "ui:description": "Lock all CLI-editable configs for this domain. When true, rose-config CLI refuses to write.",
      "x-access": "staff"
    },
    "tier": {
      "type": "string",
      "enum": [
        "lite",
        "advanced"
      ],
      "ui:widget": "knowledge-tier",
      "ui:description": "Knowledge tier. 'lite' = chunks-only retrieval, no entity graph, skips entity extraction at ingest, answers with a smaller/cheaper model. 'advanced' = full entity/relationship graph + full answer model. Required when configuring a client.",
      "x-access": "staff"
    },
    "website_migrated": {
      "type": "boolean",
      "ui:description": "Website knowledge is sourced from the new scraping system. When true, the legacy Google Drive website pass is skipped during ingestion for this client. Leave false until the client's website has been re-scraped into the new system.",
      "x-access": "staff"
    },
    "documents_migrated": {
      "type": "boolean",
      "ui:description": "Custom documents are managed in the new system (knowledge.documents), not Google Drive. When true, the Documents section is shown in the Knowledge view so the client can add and manage docs. Leave false until the client's documents have been migrated into the new system.",
      "x-access": "staff"
    },
    "eu_only": {
      "ui:sectionTitle": "Model residency",
      "ui:sectionDescription": "Restrict this client's model calls to Europe (EEA + Switzerland).",
      "ui:sectionIcon": "Shield",
      "type": "boolean",
      "ui:description": "Process conversations and private content on EU (EEA + Switzerland) model deployments. Embeddings of public website content may still be processed in the US. When on, a live chat model call with no EU-eligible route fails instead of falling back outside the EU.",
      "x-access": "staff"
    }
  },
  "allOf": [
    {
      "required": [
        "tier"
      ]
    }
  ],
  "default": {
    "api_endpoint": null,
    "evaluation_endpoint": "https://inboundx.app.n8n.cloud/webhook/evaluation-prod",
    "conversation_endpoint": "https://inboundx.app.n8n.cloud/webhook/final-prod",
    "model": null,
    "config_locked": false,
    "website_migrated": false,
    "documents_migrated": false,
    "eu_only": false
  }
}
